<div class="screen screen--recos">

  <header class="recos__head">
    <button class="recos__back" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>">
      <i class="icon icon--arrow-left"></i>
    </button>
    <div>
      <p class="belturo-eyebrow"><%= house %></p>
      <h1 class="recos__title"><%= _lcs( 'Empfehlungen' ) %> <em><%= _lcs( 'deiner Gastgeber' ) %></em></h1>
    </div>
  </header>

  <!-- Only the kinds the host actually recommended get a chip: a filter that
       leads to an empty list is a dead end, not a choice. -->
  <div class="chips recos__chips" data-id="filters">
    <% filters.forEach( function( f ) { %>
    <button class="chip<%= f.isActive ? ' chip--active' : '' %>" type="button" data-filter="<%= f.id %>">
      <i class="icon icon--<%= f.icon %> chip__icon"></i>
      <span><%= _lcs( f.label ) %></span>
      <span class="chip__count"><%= f.count %></span>
    </button>
    <% } ); %>
  </div>

  <div class="recos__grid" data-id="grid"></div>

  <p class="recos__empty" data-id="empty" hidden></p>

</div>
